import { Loading, ReferenceManyField } from "@/components/admin"
import Empty from "@/components/fornya/empty"
import { DoorClosed, Layers2 } from "lucide-react"
import StoreyCard from "./storey-card"

import RoomCard from "./room-card"
export default function EditWorkspace() {
  return (
    <div>
      <ReferenceManyField
        loading={<Loading />}
        reference="storeys"
        target="project_id"
        empty={<Empty source="floors" mode="edit" icon={<Layers2 />} />}
        render={({ data }) => (
          <>
            {data?.map(
              ({
                id,
                title,
                level,
                surface,
                rooms,
                wcs,
                bathrooms,
                status,
              }) => (
                <StoreyCard
                  mode="edit"
                  key={id}
                  {...{
                    id,
                    title,
                    level,
                    surface,
                    rooms,
                    wcs,
                    bathrooms,
                    status,
                  }}
                >
                  <ReferenceManyField
                    empty={
                      <Empty source="rooms" mode="edit" icon={<DoorClosed />} />
                    }
                    loading={<Loading />}
                    reference="rooms"
                    target="project_id"
                    filter={{ storey_id: id }}
                    render={({ data }) => (
                      <>
                        {data?.map(
                          ({
                            id,
                            title,
                            type,
                            status,
                            surface,
                            windows,
                            balconies,
                            material_ids,
                          }) => (
                            <RoomCard
                              key={title}
                              mode="edit"
                              {...{
                                id,
                                title,
                                type,
                                status,
                                surface,
                                windows,
                                balconies,
                                material_ids,
                              }}
                            ></RoomCard>
                          )
                        )}
                      </>
                    )}
                  />
                </StoreyCard>
              )
            )}
          </>
        )}
      />
    </div>
  )
}
